import request from '@/config/axios'

export interface LoginSkinVO {
  id?: number
  moduleCode: string
  moduleTitle?: string
  title?: string
  subtitle?: string
  logoUrl?: string
  loginBgUrl?: string
  buttonColor?: string
  linkColor?: string
  boundModuleCodes?: string[]
  status?: number
  createTime?: string
}

export interface LoginSkinModuleOption {
  code: string
  title: string
}

export interface LoginSkinPageReq {
  pageNo: number
  pageSize: number
  moduleCode?: string
  status?: number | undefined
}

export const LoginSkinApi = {
  getPage: (params: LoginSkinPageReq) =>
    request.get({ url: '/portal-ops/login-skin/page', params }),
  getList: () => request.get({ url: '/portal-ops/login-skin/list' }),
  get: (params: { id?: number; moduleCode?: string }) =>
    request.get({ url: '/portal-ops/login-skin/get', params }),
  save: (data: LoginSkinVO) => request.put({ url: '/portal-ops/login-skin/save', data }),
  delete: (id: number) => request.delete({ url: '/portal-ops/login-skin/delete', params: { id } }),
  getModuleOptions: (): Promise<LoginSkinModuleOption[]> =>
    request.get({ url: '/portal-ops/login-skin/module-options' })
}
